import React from "react";
import { getLocalizedString } from "@icarius-localization/strings";
import { Chip } from "@material-ui/core";
import { CloseIcon, DoneIcon } from "@icarius-icons/index";

const StatusChip = ({ passed, isExercise, showIcon }) => {

    if (passed === null || passed === undefined) return null;

    const label = (() => {
        if (isExercise) return getLocalizedString(passed ? "correct" : "incorrect");
        return getLocalizedString(passed ? "approved" : "failed");
    })();

    return (
        <Chip
            size="small"
            label={label}
            icon={showIcon ? (passed ? <DoneIcon style={{ fill: "#fff" }} /> : <CloseIcon style={{ fill: "#fff" }} />) : null}
            style={{
                width: "100%",
                background: passed ? "var(--ownGreen)" : "var(--ownRed)",
                color: "white",
            }}
        />
    )
}

export default StatusChip;